import { offEvent, onEvent } from "@adapptio/lib-shared";
import React, { FC, useEffect, useState } from "react";
import { ToolbarCommandButton } from "../../../../ui/components/Toolbar/ToolbarCommandButton";
import { useSimpleEvent } from "../../../../ui/hooks/useSimpleEvent";
import { ActionEditorView } from "../ActionEditorView";

export interface IActionEditorTesterToolbarProps {
	view: ActionEditorView;
}

export const ActionEditorTesterButton: FC<IActionEditorTesterToolbarProps> = ({ view }) => {
	const [ isExecuting, setIsExecuting ] = useState(() => view.isBeingExecuted());
	const [ resourceInfo, setResourceInfo ] = useState(() => ({
		isBeingSaved: view.isBeingSaved()
	}));

	useSimpleEvent(
		view.onExecutionStatusChange,
		() => setIsExecuting(view.isBeingExecuted()),
		[ view ],
		true
	);

	useEffect(() => {
		const handleResourceInfoChange = () =>
			setResourceInfo({
				isBeingSaved: view.isBeingSaved()
			});

		onEvent(view.onResourceInfoChanged, handleResourceInfoChange);
		onEvent(view.onViewInfoChanged, handleResourceInfoChange);
		return () => {
			offEvent(view.onResourceInfoChanged, handleResourceInfoChange);
			offEvent(view.onViewInfoChanged, handleResourceInfoChange);
		};
	}, [ view ]);

	// @todo Translate
	return (
		<ToolbarCommandButton
			icon="mdi/play"
			label={view.isModified ? "Save & Run Action" : "Run Action"}
			commandId="actionEditor.edit.saveExecute"
			isLoading={isExecuting}
			disabled={isExecuting || resourceInfo.isBeingSaved}
		/>
	);
};
